// 获取验证码
import { captcha } from "@/api/user";

export default {
    data() {
        return {
            captchaImg: "",

            // 验证码是否处于读取状态
            verifyCodeLoading: true,
        }
    },

    methods: {
        async fetchVerifyCode() {
            console.log('开始执行获取验证码操作');
            //方法一被调用，先开启验证码的读取状态
            this.verifyCodeLoading = true
            try {
                const res = await captcha()
                console.log('后端返回的数据是:', res);
                this.captchaImg = res.data.captchaImg;
            } catch (error) {
                // 这里写catch语句，完全是为了平息语法校验的 uncaught in promise的错误提示
                // 其实许多处理错误的逻辑，在request.js里已经写好了，
                // 比如带有提示的遮罩出来的这种处理。
                console.log('error:', error)
            } finally {
                //最后，不管获取验证码的结果是成功还是失败，都关闭读取状态
                this.verifyCodeLoading = false;
            }

        }
    }
    
}